import { authService } from '@src/features/auth/services';
import productApiNetworkService from '@src/services/api/product-api-network.service';

import { ProfileInfoService } from './profile-info.service';
import ProfileService from './profile.service';

export const profileService = new ProfileService(productApiNetworkService, authService);
export const profileInfoService = new ProfileInfoService(productApiNetworkService);
